import { createGlobalStyle} from 'styled-components'

export const GlobalStyle = createGlobalStyle`
    * {
        font-family: --apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        color: white;
    }

    html {
        background-color: #12c2e9;
    }
}
`
